import { noop } from 'es-toolkit';
import { createContext } from 'react';
export const InternalModalContext = createContext({
    onClose: noop,
});
